const getAuthHeaders = (token) => {
  return { Authorization: `Bearer ${token}` };
};

export { getAuthHeaders };
